export var TextButtonPriority;
(function (TextButtonPriority) {
    TextButtonPriority["primary"] = "primary";
    TextButtonPriority["secondary"] = "secondary";
    TextButtonPriority["link"] = "link";
})(TextButtonPriority || (TextButtonPriority = {}));
//# sourceMappingURL=types.js.map